<div id="cutting-maps" class="w-full h-full" fusePerfectScrollbar>
  <div class="flex flex-col gap-4 items-stretch">
    <div class="flex flex-row flex-wrap gap-4 items-stretch">
      <ng-container *ngFor="let item of maps; index as i">
        <mat-card class="cut-map-card flex flex-col">
          <mat-card-content class="flex flex-auto">
            <div [innerHtml]="item | safeHtml" (click)="openMapViewerDialog(item)" class="cutting-map"></div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </div>
  </div>
</div>
